export default "__VITE_ASSET__ChFg9Xql__"